// eslint-disable-next-line import/no-mutable-exports
let apiUrl;
const apiUrls = {
  production: "https://melillo-api.powerofpatients.com:446",
  development: "http://localhost:4242",
  test: "https://test2-api.powerofpatients.com:446",
  developmentLan: `https://${window.location.hostname}`,
};

if (window.location.hostname === "localhost") {
  apiUrl = apiUrls.development;
} else if (window.location.hostname.startsWith("192.168")) {
  apiUrl = apiUrls.developmentLan;
} else if (window.location.hostname.startsWith("test")) {
  apiUrl = apiUrls.test;
} else {
  apiUrl = apiUrls.production;
}

export default apiUrl;
